// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".pagination-container[data-v-230bec27] {\n  margin-top: 24px;\n  text-align: right;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/pages/admin/agent/components/agent-count-list.dialog.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,iBAAA;AAAF","file":"agent-count-list.dialog.vue","sourcesContent":["\n.pagination-container {\n  margin-top: 24px;\n  text-align: right;\n}\n"]}]);
// Exports
module.exports = exports;
